/**
 * @generated SignedSource<<07f58c597d94c5d0f40459225ae53e86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTempoVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateTempoVerificationKeyMutation$variables = {
  input: CreateTempoVerificationKeyInput;
};
export type CreateTempoVerificationKeyMutation$data = {
  readonly createTempoVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreateTempoVerificationKeyMutation = {
  variables: CreateTempoVerificationKeyMutation$variables;
  response: CreateTempoVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTempoVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createTempoVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTempoVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTempoVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "14872a7e9d45563c2352c4d969f63f98",
    "id": null,
    "metadata": {},
    "name": "CreateTempoVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTempoVerificationKeyMutation(\n  $input: CreateTempoVerificationKeyInput!\n) {\n  createTempoVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "427d4ebc8081e459beec71a0032a4f16";

export default node;
